import { useTranslation } from 'react-i18next';

import DocumentItem from '@/features/documents/components/DcoumentsSection/DocumentItem';
import type {
  ClaimDocument,
  Document,
  InvoiceDocument,
} from '@/features/documents/types';
import hasItems from '@/lib/utils/hasItems';

type Props = {
  documents: Array<Document | InvoiceDocument | ClaimDocument>;
};

export default function DocumentsList({ documents }: Props) {
  const { t } = useTranslation();

  return (
    <div className="mt-4 flex flex-col">
      <p>{t('DOCUMENTS_TITLE')}</p>

      {hasItems(documents) && (
        <div className="mt-2 flex flex-col gap-2">
          {documents.map((document) => (
            <DocumentItem key={document.id} document={document} />
          ))}
        </div>
      )}

      {!hasItems(documents) && (
        <span className="text-muted-foreground text-xs">
          {t('NO_DOCUMENTS')}
        </span>
      )}
    </div>
  );
}
